import Paragraph from 'src/design/styleguide/Paragraph';

export default () => <Paragraph>You do not have any transactions yet.</Paragraph>;
